
var lens = require('dot-lens')

module.exports = t

function t (locales, ptr) {
  var lng = "de"; //cookie('koa:lang')
  var locale = lens(lng + '.' + ptr)  
  return locale.get(locales)
}

/**
 * Parse cookie `str`.
 */

function cookie (name) {
  var value = "; " + document.cookie
  var parts = value.split("; " + name + "=")
  if (parts.length == 2) return parts.pop().split(";").shift();
}


// WEBPACK FOOTER //
// ./lib/translate/index.js